import {
  DataField,
  Divider,
  H2,
  H3,
  Section,
  P,
  CheckList,
} from "./common-components";

export const MedicationReasonCheckList = ({ formType, preAssessment }) => {
  const reasonsPart1 = [
    { label: "To learn more about my prescription medications.", checked: preAssessment.reasonsForMedicationReview.includes("To learn more about my prescription medications") },
    { label: "To learn more about non-prescription medications, vitamins, or natural health products.", checked: preAssessment.reasonsForMedicationReview.includes("To learn more about non-prescription medications, vitamins, or natural health products") },
    { label: "To learn more about how to manage my chronic conditions.", checked: preAssessment.reasonsForMedicationReview.includes("To learn more about how to manage my chronic conditions") },
    { label: "To learn if my medication is working for me.", checked: preAssessment.reasonsForMedicationReview.includes("To learn if my medication is working for me.") },
    { label: "To learn how to manage side effects.", checked: preAssessment.reasonsForMedicationReview.includes("To learn how to manage side effects") },
    { label: "To learn the importance of medications that need routine laboratory monitoring.", checked: preAssessment.reasonsForMedicationReview.includes("To learn the importance of medications that need routine laboratory monitoring.") },
  ];
  const reasonsPart2 = [
    { label: "Recent discharge from hospital (within 2 weeks).", checked: preAssessment.reasonsForMedicationReview?.includes("I had a recent discharge from hospital.") ?? false },
    { label: "Planned upcoming hospital admission.", checked: preAssessment.reasonsForMedicationReview?.includes("I have a planned upcoming hospital admission.") ?? false },
  ];

  return (
    <Section formType={formType}>
      <H2>Reason(s) for Medication Review</H2>
      <div className="flex flex-col gap-1">
        <CheckList list={reasonsPart1} />
        <div className="border-b border-gray-100 my-1" />
        <CheckList list={reasonsPart2} />
      </div>
    </Section>
  );
};
